import { toast } from "react-toastify";
import axiosInstance from "../../../axios";

//get company role list
export const getCompanyRole = async (payload) => {
  console.log("abccc",payload?.searchKey?.length);
  try {
    if(payload?.searchKey?.length>0)
    {
      const response = await axiosInstance.get(`/career?searchName=${payload.searchKey}&pageLength=${payload.currentPageLimit}&pageNo=${payload.currentPage}`);
      return response.data;
    }
    else
    {
      const response = await axiosInstance.get(`/career?searchName=${payload.searchKey}&pageLength=${payload.currentPageLimit}&pageNo=${payload.currentPage}`);
      return response.data;
    }
   
  } catch (error) {
    throw error;
  }
};

//get company role by id
export const getCompanyRoleById = async (payload) => {
  try {
   
      const response = await axiosInstance.get(`/career/${payload}`);
      return response.data;
   
   
  } catch (error) {
    throw error;
  }
};

//get category list
export const getCategoryList = async (payload) => {
  console.log("abccc",payload);
  try {
    const response = await axiosInstance.get(`/career/category`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//add New Job
export const addNewJob = async (payload) => {
  console.log("abccc",payload);
  try {
    const response = await axiosInstance.post(`/career`,payload);
    return response.data;
  } catch (error) {
    console.log("error");    
  }
};


//add New Job
export const editNewJob = async (payload) => {
  console.log("abccc",payload);
  try {
    const response = await axiosInstance.patch(`/career/${payload?.id}`,payload?.payload);
    return response.data;
  } catch (error) {
    console.log(error?.response?.data,'abcc',error?.response)
    // throw error?.response
    // return error?.response
  }
};

//edit applicant
export const editApplicantService = async (payload) => {
  console.log("abccc",payload);
  try {
    const response = await axiosInstance.patch(`/career/applicant/${payload?.id}`,payload?.payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};



//get applicant list
export const getApplicantRole = async (payload) => {
  console.log(payload,'payload11')
  try {
    if(payload?.applicantSearchKey?.length>0)
    {
      const response = await axiosInstance.get(`/career/applicant?searchName=${payload.applicantSearchKey}&pageLength=${payload.applicantCurrentPageLimit}&pageNo=${payload.applicantCurrentPage}&category=${payload.category}`);
      console.log(response,'responseee')
      return response.data;
    }
    else
    {
      const response = await axiosInstance.get(`/career/applicant?category=${payload.category}&pageLength=${payload.applicantCurrentPageLimit}&pageNo=${payload.applicantCurrentPage}`);
      console.log(response,'responseee')
      return response.data;
    }
   
  } catch (error) {
    console.log(error,'responseee')

    throw error;
  }
};

//get applicant role by id
export const getApplicantRoleById = async (payload) => {
  try {
   
      const response = await axiosInstance.get(`/career/applicant/${payload}`);
      console.log(response,'responseee')
      return response.data;
  
   
  } catch (error) {
    console.log(error,'responseee')

    throw error;
  }
};


